import { create } from 'zustand';

export interface McQuizSection {
  id: number;
  title: string;
  description?: string;
  position: number;
  question_count?: number;
  questions?: any[];
}

export interface McQuizStore {
  currentTest: any | null;
  sections: McQuizSection[];
  isDirty: boolean;

  setCurrentTest: (test: any) => void;
  addSection: (section: McQuizSection) => void;
  removeSection: (sectionId: number) => void;
  updateSection: (sectionId: number, data: Partial<McQuizSection>) => void;
  setSections: (sections: McQuizSection[]) => void;
  markDirty: () => void;
  reset: () => void;
}

export const useMcQuizStore = create<McQuizStore>((set) => ({
  currentTest: null,
  sections: [],
  isDirty: false,

  setCurrentTest: (test) =>
    set({
      currentTest: test,
      sections: test?.sections ?? [],
      isDirty: false,
    }),

  addSection: (section) =>
    set((state) => ({
      sections: [...state.sections, section],
      isDirty: true,
    })),

  removeSection: (sectionId) =>
    set((state) => ({
      sections: state.sections.filter((s) => s.id !== sectionId),
      isDirty: true,
    })),

  updateSection: (sectionId, data) =>
    set((state) => ({
      sections: state.sections.map((s) =>
        s.id === sectionId ? { ...s, ...data } : s,
      ),
      isDirty: true,
    })),

  setSections: (sections) => set({ sections, isDirty: true }),

  markDirty: () => set({ isDirty: true }),

  reset: () =>
    set({
      currentTest: null,
      sections: [],
      isDirty: false,
    }),
}));
